/** Публичный адрес fanfics-api, доступный из браузера пользователя. */
export const PUBLIC_API_URL =
  (process.env.NEXT_PUBLIC_API ?? '').trim() || 'https://api-fanfic.staging.lorium.online';

/** Внутренний адрес fanfics-api для SSR, Route Handlers и NextAuth. */
export const SERVER_API_URL = (process.env.FANFICS_API_INTERNAL_URL ?? '').trim() || PUBLIC_API_URL;

/**
 * Общий адрес для модулей, которые используются в обоих окружениях.
 * В браузерную сборку внутренний адрес не попадает.
 */
export const BACKEND_API_URL = typeof window === 'undefined' ? SERVER_API_URL : PUBLIC_API_URL;
